import { render, staticRenderFns } from "./OperaShipmentsWindow.vue?vue&type=template&id=0cdf6047&scoped=true&"
import script from "./OperaShipmentsWindow.vue?vue&type=script&lang=js&"
export * from "./OperaShipmentsWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaShipmentsWindow.vue?vue&type=style&index=0&id=0cdf6047&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdf6047",
  null
  
)

export default component.exports